let env = process.env.NODE_ENV
const globalUrl = env === 'production' ? '' : 'ipa/'
const globalUrl2 = env === 'production' ? '' : 'api/'
import store from '@/store/store'
/**
* @method:添加页面路径，图标等，用于登录后侧边栏路由赋予，首页图标赋予路径，图标及权限判断
* @params e:二级目录对象
* @params type：类型，login表只获取路径，allMuneAndRight用于获取图标等，right判断该菜单是否要判断权限
*/
const getMuneRight = (e, type, right) => {
  let returnMeg = ''
  let rightName
  switch (e.id) {
    case '10022':
      returnMeg = type === 'login' ? '/declareDutiableRecode' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_03.png') })
      break
    case '10023':
      returnMeg = type === 'login' ? '/incomeAccount' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/quick_10.png') })
      break
    case '10081':
      returnMeg = type === 'login' ? '/endDeclareRecode' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_07.png') })
      break
    case '10024':
      if (right) rightName = 'taxPlayerRight'
      returnMeg = type === 'login' ? '/taxpayerList' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/quick_05.png') })
      break
    case '10025':
      returnMeg = type === 'login' ? '/taxpayerApproval' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_11.png') })
      break
    case '10026':
      returnMeg = type === 'login' ? '/statisticalForm' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_61.png') })
      break
    case '10069':
      returnMeg = type === 'login' ? '/declareStatistiacal' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_64.png') })
      break
    case '10160':
      returnMeg = type === 'login' ? '/accountStatement' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_73.png') })
      break
    case '10099':
      returnMeg = type === 'login' ? '/capitalFlow' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_66.png') })
      break
    case '10021':
      returnMeg = type === 'login' ? '/baseInfo' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_75.png') })
      break
    case '10097':
      returnMeg = type === 'login' ? '/balance' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_77.png') })
      break
    case '10133':
      if (right) rightName = 'messageRight'
      returnMeg = type === 'login' ? '/message' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/quick_08.png') })
      break
    case '10027':
      returnMeg = type === 'login' ? '/operatorList' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_78.png') })
      break
    case '10028':
      returnMeg = type === 'login' ? '/roleList' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_74.png') })
      break
    case '10102':
      returnMeg = type === 'login' ? '/otherPayOrder' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_27.png') })
      break
    case '10103':
      returnMeg = type === 'login' ? '/otherPayExport' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_79_07.png') })
      break
    case '10104':
      returnMeg = type === 'login' ? '/rechargeRecode' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_34.png') })
      break
    case '10111':
      if (right) rightName = 'taskRight'
      returnMeg = type === 'login' ? '/order' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_24.png') })
      break
    case '10112':
      returnMeg = type === 'login' ? '/orderImport' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_31.png') })
      break
    case '10149':
      if (right) rightName = 'applyRight'
      returnMeg = type === 'login' ? '/invoiceApply' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_40.png') })
      break
    case '10150':
      if (right) rightName = 'invoiceRight'
      returnMeg = type === 'login' ? '/applyRecode' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_37.png') })
      break
    case '10173':
      returnMeg = type === 'login' ? '/taskSetttings' : ({ name: e.name, path: e.path, id: e.id, img: require('@/assets/shortcm_80_03.png') })
      break
    default:
      break
  }

  if (type === "login" || (type !== "login" && !right)) return returnMeg
  let returnObj = {}
  returnObj.returnMeg = returnMeg
  returnObj.rightName = rightName
  return returnObj
}
/**
* @method:各个页面的权限判断
* @params _id要校验权限id
* @return {boolean} 是否有权限
*/
const getIndependentRight = (id) => {
  let delayeringMune = store.state.delayeringMune
  let rightRes = false
  delayeringMune.forEach(e => {
    if (e.id === id) rightRes = true
  })
  return rightRes
}
export default {
  globalUrl,
  globalUrl2,
  getMuneRight,
  getIndependentRight
}



// WEBPACK FOOTER //
// ./src/utils/global.js